import React from 'react';
import SystemItem from './SystemItem/SystemItem';
import { lists } from 'seal-ui-components';

const SystemPanel = ({
    sealSystems,
    selectedSystemId,
    toggleAuthType,
    AuthSectionState,
    OnSystemClick,
    removeSystem,
    setFriendlyName,
    setUrl,
    editSealSystem,
    logout,
    activeSystem
}) => (
    <lists.List>
        {sealSystems &&
            sealSystems.map((s, index) => (
                <SystemItem
                    key={s.id}
                    id={s.id}
                    index={index}
                    logout={logout}
                    authSection={s.authSection}
                    AuthSectionState={AuthSectionState}
                    authToken={s.authToken}
                    authType={s.authType}
                    removeSystem={removeSystem}
                    editSealSystem={editSealSystem}
                    setFriendlyName={setFriendlyName}
                    sealSystems={sealSystems}
                    setUrl={setUrl}
                    username={s.principal}
                    friendlyName={s.friendlyName}
                    sealUrl={s.sealUrl}
                    tokenIssueTime={s.tokenIssueTime}
                    checked={activeSystem === s.sealUrl}
                    selectedSystemId={selectedSystemId}
                    OnSystemClick={OnSystemClick}
                    toggleAuthType={toggleAuthType}
                    label={s.friendlyName}
                />
            ))}
    </lists.List>
);

export default SystemPanel;
